import * as React from 'react';

import TabsUnderlined from 'components/tabs/tabs-underlined/TabsUnderlined';

import { __t, applyTranslations } from 'utils/language';

import './creator-tile-sizing.scss';

import type { SyntheticEvent } from 'react';

applyTranslations(require('./creator-tile-sizing.i18n.json'));

type Props = {
  onGlobalResize: (value: string) => void,
  toggleIdsMap: {
    [type: number]: string
  }
};

const msgKey = 'creator_tile_sizing';
const EXPANDED = 'expanded';
const COLLAPSED = 'collapsed';

class CreatorTileSizing extends React.PureComponent<Props> {
  handleResize = (event: SyntheticEvent<HTMLElement>): void => {
    const { onGlobalResize } = this.props;
    const target = event.currentTarget;
    const type = target.dataset.arg || '';

    onGlobalResize(type);
  };

  render(): React.ReactNode {
    const { toggleIdsMap } = this.props;

    const tabItems = [EXPANDED, COLLAPSED]
      .map(type => ({
        handleClick: this.handleResize,
        handleClickArg: type,
        label: __t(`${msgKey}.labels.${type}`)
      }));

    return (
      <section className="creator-tile-sizing">
        <div className="creator-tile-sizing__label">
          {__t(`${msgKey}.labels.view_as`)}:
        </div>
        <div className="creator-tile-sizing__tabs">
          <TabsUnderlined
            items={tabItems}
            toggleIdsMap={toggleIdsMap}
          />
        </div>
      </section>
    );
  }
}

export default CreatorTileSizing;
